import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const LogSystemUdalosti = {
	name: NAME,
	apiProvider,
	router,
};
